export default __webpack_public_path__ + "static/media/eleImg_pwd_2_4.a71d05b8.png";